import { AfterViewInit, ChangeDetectorRef, Component, Injector, OnDestroy, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ComponentService } from '../../shared/abstract/component.service';
import { RoleEnums } from '../../shared/enum/authorize';
import { AuthService } from '../../shared/auth/auth.service';
import { ApplicationService } from './application.service';
import { MediaMatcher } from '@angular/cdk/layout';
import { catchError, interval, of, Subscription, switchMap } from 'rxjs';
import { RequestService } from '../../shared/services/request.service';
import { FileManagerService } from '../../shared/services/file-manager.service';
import { GeneralQueryModel } from '../../shared/model/general-query-model';
import { CalculationType } from '../../shared/enum/calculation-type';
import { environment } from "../../environments/environment";
import { FontSizeState } from '../../shared/enum/font-size-states';
import { ModalComponent } from '../../shared/widgets/modal/modal.component';
import { MatDialog } from '@angular/material/dialog';
import { UserManagementComponent } from '../admin/user-management/user-management.component';

@Component({
  selector: 'app-application',
  templateUrl: './application.component.html',
  styleUrl: './application.component.css'
})
export class ApplicationComponent extends ComponentService<any> implements OnInit, OnDestroy {

  subscription!: Subscription;
  @Output() userInfos;
  private mobileQueryListener: () => void;
  public mobileQuery: MediaQueryList;
  userType;
  projects: any = [];
  isLoaded = true;
  roleEnums = RoleEnums;
  calculationSubs: Subscription | undefined;
  calculationType = CalculationType;
  state: any;
  fontSizeState = FontSizeState;
  _currentLogoObjectUrl:any;
  
  userManagementModalSubscription!: Subscription;



    constructor(injector: Injector, private _dialog: MatDialog, private route: ActivatedRoute, private _router: Router,
        private _auth: AuthService, private _applicationSerivce: ApplicationService,
        public changeDetectorRef: ChangeDetectorRef, media: MediaMatcher, private _request: RequestService, private fileManager: FileManagerService) {
    super(injector);
    this.mobileQuery = media.matchMedia('(max-width: 800px)');
    this.mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this.mobileQueryListener);

  }



  ngOnInit(): void {

    //initialize userInfos variable in appsService
    if (this.mobileQuery.matches) {
      this._appsService.mobileScreen = true;
    }
    else {
      this._appsService.mobileScreen = false;
    }
    this.userInfos = this._appsService.userInfo();
    this.subscription = this._appsService.projectData.subscribe(res => {
      if (res) {
        this.onSelectedProject(res);
      }
    })

    this._auth.authControl(localStorage.getItem('ut'));
    if (this.userInfos.RoleId != null) {
      if ([RoleEnums.SuperAdmin, RoleEnums.Admin, RoleEnums.CompanyAdmin].includes(this.userInfos.RoleId)) {
        this.adminInit();
      } else {
        this.userInit();
        if (RoleEnums.Supervisor == this.userInfos.RoleId) {
          this.userType = RoleEnums.Supervisor;
        }
        if (RoleEnums.TeamLeader == this.userInfos.RoleId) {
          this.userType = RoleEnums.TeamLeader;
        }
        if (RoleEnums.LdapUser == this.userInfos.RoleId) {
          this.userType = RoleEnums.LdapUser;
        }
      }




    }
    //this._appsService.sidebarData.subscribe((res) => {
    //  if (res) {
    //    this.sideList = res;
    //  }
    //});

    //this._router.navigate(['application/dashboard/']);
    this.calculationInterval();
    
    // Subscribe to user management modal control
    this.userManagementModalSubscription = this._appsService.applicationUserManagementSidebarControl.subscribe((data) => {
      if (data && data.state === 'open') {
        this.openUserManagementModal();
      }
    });

  }
  
  ngOnDestroy(): void {
    this.calculationSubs ? this.calculationSubs.unsubscribe() : false;
    if (this.userManagementModalSubscription) {
      this.userManagementModalSubscription.unsubscribe();
    }
  }
  
  openUserManagementModal(): void {
    const dialogRef = this._dialog.open(UserManagementComponent, {
      width: '90vw',
      maxWidth: '1400px',
      height: '90vh',
      maxHeight: '900px',
      disableClose: false,
      panelClass: 'user-management-modal'
    });
    
    dialogRef.afterClosed().subscribe(() => {
      // Modal kapandığında yapılacak işlemler
    });
  }



  onSelectedProject(projectId: number) {
    this._applicationSerivce.setCurrentProject(projectId).then(_ => {
      const p = this.projects.find(p => p.id == projectId);
      p != null ? this._appsService.getCurrentProject(p) : false;
      this._appsService.getSettings();
      this.isLoaded = false;

    })
  }


  async calculationInterval() {
    if (this.calculationSubs != undefined) {
      this.calculationSubs.unsubscribe();
    }
    this.calculationSubs = interval(60000).pipe(
      switchMap(() =>
        this._request.getCalculationResult(this._appsService.existCurrentProject.companyId,
          this._appsService.existCurrentProject.projectId,
        ).then((res) => {
          if (res.code == 1 && res.data != null) {
            if (res.data.calculationTypeId == this.calculationType.Tsp) {
              if (res.data.calculationState == "END" && res.data.taskPercent == 100) {
                this._appsService.tspControl.next(true);
              }
            }
          }
        })
      ),
      catchError((error) => of(error))
    ).subscribe((res) => {

    })
  }

  adminInit() {
    this._appsService.getUserInfoRequest().then(_ => {
      //this.themeControl(_.theme);
    }).finally(() => {
      if (this._appsService.userInfos.role == this.roleEnums[this.roleEnums.Admin] || this._appsService.userInfos.role == this.roleEnums[this.roleEnums.SuperAdmin]) {
        this.userType = this.roleEnums.Admin;
        this._applicationSerivce.getCompanies().then(_ => {
          if (_) {
            this._appsService.companies = _;
            this._appsService.companies.sort(this.turkishSortCompany);
            this._appsService.filterCompanies = JSON.parse(JSON.stringify(this._appsService.companies))
            this._appsService.companies = this._appsService.companies;
            if (this._appsService.userInfos.lastCompanyId) {
              this._appsService.selectedCompany = this._appsService.userInfos.lastCompanyId;
              this._appsService.existCurrentCompany = this._appsService.userInfos.lastCompanyId;
              this.onSelectedCompany(this._appsService.userInfos.lastCompanyId);
            } else {
              this._appsService.selectedCompany = this._appsService.companies[0].id;
              this.onSelectedCompany(this._appsService.companies[0].id);
              this._appsService.existCurrentCompany = this._appsService.companies[0].id;

            }
            this._request.getCompanyWithoutAuth(this._appsService.existCurrentCompany).then(_ => {
              this._appsService.userLayers = _.layer;
            })
            localStorage.setItem('cId', this._appsService.selectedCompany);
          }
        }).finally(() => {
          this._appsService.isAdmin = true;
          this.displayKvkkDocuments();
          //this.isLoaded = false;
          //this.getSideList();

        })
      } else if (this._appsService.userInfos.role == this.roleEnums[this.roleEnums.CompanyAdmin]) {
        this.userType = this._appsService.userInfos.roleId
        this._appsService.isAdmin = false;
        localStorage.setItem('cId', this._appsService.userInfos.companyId);
        this._appsService.selectedCompany = this._appsService.userInfos.companyId;
        this._appsService.existCurrentCompany = this._appsService.userInfos.companyId;
        this._request.setCurrentCompany(this._appsService?.userInfos?.companyId).then((res) => {
          if (res.code == 1) {
            localStorage.setItem('cId', this._appsService?.userInfos?.companyId.toString())
          }
        })
        this._request.getProjects(this._appsService.userInfos.companyId).then(_ => {
          this.projects = _;
          this.projects.sort(this.turkishSortProject)
          this.subProjectControl(this.projects)
          this._appsService.projects = this.projects;
          this.projects.forEach(p => { p.projectId = p.id });
          if (this.projects.length > 1) {
            if (this._appsService.userInfos.lastProjectId) {
              this._appsService.selectedProject = this._appsService.userInfos.lastProjectId;
              this.onSelectedProject(this._appsService.userInfos.lastProjectId);
            } else {
              this._appsService.selectedProject = this.projects[0].projectId;
              this.onSelectedProject(this.projects[0].projectId);
            }
          }
          else {
            this._appsService.selectedProject = this.projects[0].projectId;
            this.onSelectedProject(this.projects[0].projectId);
          }
        }).finally(() => {
          if (this.projects.length != 0) {
            this._appsService.isLoaded = true;
          } else {
            this._appsService.isLoaded = false;
            this.projects = [];
            this.MessageBox(this.languageKey("companyOwnedProjectNotFound"), 'orange', 'center');
          }
          this.checkAppObjRule();
          //this.checkVrpRule();
          this.getAllWorkRules();
          this.getVCompanyProjectInfo();
          this.getPoiCategories();
          //this.getSideList();
          this.setUserLayers();
          this.getPaginateDynamicPois();
          this.displayKvkkDocuments();
          this.refreshToken();

        })
      }


    });
  }



  onSelectedCompany(companyId: number) {
    this._appsService.projects = [];
    this._request.setCurrentCompany(companyId).then(_ => {
      if (_.code == 1) {
        this._appsService.existCurrentCompany = companyId;
        localStorage.setItem('cId', companyId.toString())
      }
      else if (_.code == 2) {
        this.MessageBox(_.message ?? '', 'orange', 'center');
      }
      else {
        this.MessageBox(_.message ?? '', 'warn', 'center');
      }
    }).finally(() => {
      this._appsService.selectedCompany = companyId;
      this._appsService.existCurrentCompany = companyId;
      this._request.getProjects(companyId).then(_ => {
        this.projects = _;
        this.projects.sort(this.turkishSortProject);
        this.subProjectControl(this.projects);
        if (_) {
          this.projects.forEach(p => { p.projectId = p.id })
          this._appsService.selectedProject = this._appsService.userInfos.lastProjectId ? this._appsService.userInfos.lastProjectId : this.projects[0].id;
        }
        this._appsService.projects = this.projects

      }).finally(() => {
        if (this.projects.length != 0) {
          //this.onSelectedProject(this.projects[0].id)
          //burada kullanıcın last project Id'sı setlenmeli
          this.onSelectedProject(this._appsService.userInfos.lastProjectId ? this._appsService.userInfos.lastProjectId : this._appsService.userInfos.lastProjectId);

          this.checkAppObjRule();
          this.getAllWorkRules();
          this.getVCompanyProjectInfo();
          //this.checkVrpRule();
          this.getPoiCategories();
          this.setUserLayers();
          this.getPaginateDynamicPois();
          this.refreshToken();

          this._appsService.isLoaded = true;
        } else {
          this._appsService.isLoaded = false;
          this.projects = [];
          this.isLoaded = false;
          //this._appsService.getCurrentProject(null)
          this.MessageBox(this.languageKey("companyOwnedProjectNotFound"), 'orange', 'center');
        }

      })
    })
  }

  subProjectControl(projects) {
    let p: any = []
    projects.forEach((project) => {
      p.push(project);
      if (project.inverseParent.length != 0) {
        project.inverseParent.sort(this.turkishSortProject);
        p.push(...project.inverseParent);
      }
    });
    this.projects = p;
  }




  async userInit() {
    this._appsService.getUserInfoRequest().then(async _ => {
      this._appsService.isAdmin = false;
      this._appsService.existCurrentCompany = _.companyId;
      this._request.getCompanyWithoutAuth(_.companyId as any).then(_ => {
        this._appsService.userLayers = _.layer;
      })
      this._appsService.selectedCompany = _.companyId;
      this._request.setCurrentCompany(_.companyId).then((res) => {
        if (res.code == 1) {
          localStorage.setItem('cId', _.companyId?.toString() ?? '');
        }
      });
      this._appsService.userInfos = _;
      this.projects = _.userProjects;
      let p: any = []
      this.projects.forEach((project) => {
        p.push(project);
        if (project.subProjects.length != 0) {
          project.subProjects.forEach(p => {
            p.authorizations = project.authorizations
          });
          p.push(...project.subProjects);
        }
      });
      this.projects = p;
      this._appsService.projects = this.projects;
      if (_.lastProjectId) {
        this._appsService.selectedProject = _.lastProjectId;
      } else {
        this._appsService.selectedProject = this.projects[0].projectId;
        this._appsService.userInfos.projectId = this.projects[0].projectId;
      }
      await this._appsService.getCurrentProject(this.projects.find(p => p.projectId == this._appsService.selectedProject));
    }).finally(() => {
      if (this.projects?.length > 0) {
        //this.getSideList();
        this.checkAppObjRule();
        this.getAllWorkRules();
        this.getVCompanyProjectInfo();
        //this.checkVrpRule();
        this.getPoiCategories();
        //this._appsService.getSettings();
        this.setUserLayers();
        this.getPaginateDynamicPois();
        this.displayKvkkDocuments();
        this.isLoaded = false;
        this.refreshToken();

      }
      else {
        this.isLoaded = false;
        this.MessageBox(this.languageKey("noUSerAssignToProject"), "orange", "center");
        this._router.navigate(['account/login']);
      }
    })
  }


  displayKvkkDocuments()
  {
    if (!this._appsService.userInfos.isVerified) {
      const dialogRef = this._dialog.open(ModalComponent, {
        width: '60vw',
        height:'100vw',
        disableClose: true,
        data: {
          type: 'kvkk',
          title: 'teamSelection',
          ok: 'confirm',
          cancel: 'cancel',
          color: 'warn',
          mode: 'approval'
        }
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result && result.valid) {
          this._request.VerifyKvkkForUser(this._appsService.userInfos.id).then(res => {
            if (res && res.code == 1) {
              this.MessageBox(this.languageKey('kvkkVerified'), 'primary', 'center');
              window.dispatchEvent(new CustomEvent('tutorial-kvkk-ready'));
            } else {
              this.MessageBox(this.languageKey('anErrorOccuredOperation'), 'warn', 'center');

            }
          })
        }
      });

    } else {
      window.dispatchEvent(new CustomEvent('tutorial-kvkk-ready'));
    }
  }

  setUserLayers() {
    this._request.getCompanyWithoutAuth(this._appsService.existCurrentCompany).then((res) => {
      if (res != null) {
        this._appsService.userLayers = res.layer;
      }
    })
  }

  getPaginateDynamicPois() {
    let poiModel = new GeneralQueryModel();
    poiModel.companyId = this._appsService.existCurrentCompany;
    poiModel.projectId = this._appsService.selectedProject;
    poiModel.searchValues = [];
    poiModel.propertyNames = [];
    poiModel.and = true;
    poiModel.orderColumn = null as any;
    poiModel.order = null as any;
    poiModel.index = 0;
    poiModel.size = 10;
    this._request.getPaginateDynamicPois(poiModel).then((res) => {
      if (res.count > 0) {
        this._appsService.staticPoiExsit = true;
      }
      else {
        this._appsService.staticPoiExsit = false;
      }
    })
  }

  getAllWorkRules() {
    this._request.getAllWorkRulesWithUnion(this._appsService.selectedCompany, this._appsService.selectedProject).then((res) => {
      if (res) {
        this._appsService.allWorkRules = res;
        if (res.OTHER_COUNTRY != undefined && res.OTHER_COUNTRY.value != undefined) {
          this._appsService.otherCountry = JSON.parse(res.OTHER_COUNTRY.value);
        }
        if (res.ATS_ACTIVE != undefined && res.ATS_ACTIVE.value != undefined) {
          this._appsService.atsRule = JSON.parse(res.ATS_ACTIVE.value);
        }
        if (res.CUSTOMER_NAME != undefined && res.CUSTOMER_NAME.value != undefined) {
          this._appsService.customerName = JSON.parse(res.CUSTOMER_NAME.value);
        }
        if (res.CATCHMENT_ACTIVE != undefined && res.CATCHMENT_ACTIVE.value != undefined) {
          this._appsService.catchmentRule = JSON.parse(res.CATCHMENT_ACTIVE.value);
        }
        if (res.DYNAMIC_POI_CATCHMENT_ACTIVE != undefined && res.DYNAMIC_POI_CATCHMENT_ACTIVE.value != undefined) {
          this._appsService.dynamicPoiCatchmentRule = JSON.parse(res.DYNAMIC_POI_CATCHMENT_ACTIVE.value);
        }
        if (res.STATIC_POI_CATCHMENT_ACTIVE != undefined && res.STATIC_POI_CATCHMENT_ACTIVE.value != undefined) {
          this._appsService.staticPoiCatchmentRule = JSON.parse(res.STATIC_POI_CATCHMENT_ACTIVE.value);
        }
        if (res.TASK_STATUS != undefined && res.TASK_STATUS.value != undefined) {
          this._appsService.taskRule = JSON.parse(res.TASK_STATUS.value);
        }
        if (res.REGIONAL_CATCHMENT_ACTIVE != undefined && res.REGIONAL_CATCHMENT_ACTIVE.value != undefined) {
          this._appsService.regionalCatchmentRule = JSON.parse(res.REGIONAL_CATCHMENT_ACTIVE.value);
        }
        if (res.VRP_ACTIVE != undefined && res.VRP_ACTIVE?.value != undefined) {
          this._appsService.vrpActive = JSON.parse(res.VRP_ACTIVE.value);
        }
        if (res.TSP_ACTIVE != undefined && res.TSP_ACTIVE?.value != undefined) {
          this._appsService.tspActive = JSON.parse(res.TSP_ACTIVE.value);
        }
        if (res.VISIT_PLAN_DETAIL != undefined && res.VISIT_PLAN_DETAIL?.value != undefined) {
          this._appsService.planDetailActive = JSON.parse(res.VISIT_PLAN_DETAIL.value);
        }
        if (res.ROUTE_ADVANCE_ACTIVE != undefined && res.ROUTE_ADVANCE_ACTIVE?.value != undefined) {
          this._appsService.routeAdvanceActive = JSON.parse(res.ROUTE_ADVANCE_ACTIVE.value);
        }
        if (res.ADDRESS_RULE != undefined && res.ADDRESS_RULE?.value != undefined) {
          this._appsService.addressRule = JSON.parse(res.ADDRESS_RULE.value);
        }
        if (res.COORDINATE_COPY_RULE != undefined && res.COORDINATE_COPY_RULE?.value != undefined) {
          this._appsService.coordinateCopyRule = JSON.parse(res.COORDINATE_COPY_RULE.value);
        }
        if (res.SNAP_MAX_DISTANCE != undefined && res.SNAP_MAX_DISTANCE?.value != undefined) {
          this._appsService.snapMaxDistance = JSON.parse(res.SNAP_MAX_DISTANCE.value);
        }
        if (res.CONSOLIDATE_DISTANCE != undefined && res.CONSOLIDATE_DISTANCE?.value != undefined) {
          this._appsService.consolidateDistance = JSON.parse(res.CONSOLIDATE_DISTANCE.value);
        }
        if (res.ASSIGNED_COMPLETION_COLOR != undefined && res.ASSIGNED_COMPLETION_COLOR?.value != undefined && res.ASSIGNED_COMPLETION_COLOR?.value != '#000000') {
          this._appsService.assignedCompletionColor = res.ASSIGNED_COMPLETION_COLOR.value;
        }
        if (res.WORK_ASSIGNMENT_SUGGESTION != undefined && res.WORK_ASSIGNMENT_SUGGESTION?.value != undefined) {
          this._appsService.workAssignmentSuggestion = JSON.parse(res.WORK_ASSIGNMENT_SUGGESTION.value);
        }
        if (res.WORK_ASSIGNMENT_SUGGESTION_DISTANCE != undefined && res.WORK_ASSIGNMENT_SUGGESTION_DISTANCE?.value != undefined) {
          this._appsService.workAssignmentSuggestionDistance = JSON.parse(res.WORK_ASSIGNMENT_SUGGESTION_DISTANCE.value);
        }
        if (res.WORK_SUGGESTION != undefined && res.WORK_SUGGESTION?.value != undefined) {
          this._appsService.workSuggestionRule = JSON.parse(res.WORK_SUGGESTION.value);
        }
        if (res.TEAM_KPI != undefined && res.TEAM_KPI?.value != undefined) {
          this._appsService.teamKipRule = JSON.parse(res.TEAM_KPI.value);
        }
      }
    })
  }

  checkAppObjRule() {
    if (!!this._appsService.existCurrentCompany) {
      this._request.getWorkRuleByKey(this._appsService.objecRuleKey, this._appsService.existCurrentCompany, null)
        .then((res) => {
          this._appsService.appObjectRule = res;
          if (this._appsService.mobileScreen) {
            this._appsService.appObjectRule.value = 'false';
          }
        })
    }
  }

  getVCompanyProjectInfo() {
    this._request.getVCompanyProjectInfo(this._appsService.selectedCompany, this._appsService.selectedProject).then((res) => {
      if (res) {
        this._appsService.companyLogo = res.companyLogoUrl;
        this._appsService.companyColorCode = res.companyColorCode;
        this._appsService.companyFontState = res.companyFontState;
        this._appsService.projectLogo = res.projectLogo;
        this._appsService.projectColorCode = res.projectColorCode;
        this._appsService.projectFontState = res.projectFontState;
        /* this._appsService.logoUrl = environment.apiUrl + "/" + (this._appsService?.projectLogo ? this._appsService?.projectLogo : (this._appsService.companyLogo ? this._appsService.companyLogo : environment.defaultLogoPath));*/
        // Prefer project logo via FileManagerService.loadImage; fall back to company logo
        // loadImage(entityName, entityId, model?) returns objectUrl in .objectUrl
        (async () => {
          try {
            // revoke previous
            if (this._currentLogoObjectUrl) {
              this.fileManager.revokeObjectUrl(this._currentLogoObjectUrl);
              this._currentLogoObjectUrl = null;
            }

            // Try project logo first
            let result = null as any;
            if (this._appsService.selectedProject) {
              result = await this.fileManager.loadImage('ProjectLogo', this._appsService.selectedProject, null);
            }

            // if no project logo, try company logo
            if (!result || !result.hasImage) {
              result = await this.fileManager.loadImage('CompanyLogo', this._appsService.selectedCompany || this._appsService.existCurrentCompany, null);
            }

            if (result && result.hasImage && result.objectUrl) {
              this._currentLogoObjectUrl = result.objectUrl;
              this._appsService.logoUrl = result.objectUrl;
            } else {
              this._appsService.logoUrl = null;
            }
          } catch (e) {
            console.warn('Error loading logo via FileManagerService', e);
            this._appsService.logoUrl = null;
          }
        })();

        var companyColor = this._appsService?.companyColorCode?.toLowerCase();
        var projectColor = this._appsService?.projectColorCode?.toLowerCase();
        if (companyColor === '#ffffff') {
          companyColor = null;
          this._appsService.companyColorCode = null;
        }
        if (projectColor === '#ffffff') {
          projectColor = null;
          this._appsService.projectColorCode = null;
        }
        if (companyColor == null || projectColor == null) {
          this._appsService.defaultLogo = "assets/logos/teamer.png";
        } else {
          this._appsService.defaultLogo = "assets/logos/teamer_logo_beyaz.png";
        }

      }
      this.setFormSizeClass();

    });
  }

  setFormSizeClass() {
    const projectState = this._appsService.projectFontState;
    const companyState = this._appsService.companyFontState;

    if (projectState !== undefined) {
      this.state = projectState;
    }
    else if (companyState !== undefined) {
      this.state = companyState;
    }
    // Her ikisi de yoksa, varsayılan Small durumunu ayarlıyoruz
    else {
      this.state = this.fontSizeState.Small;
    }
    this._appsService.classes = this.getClass(this.state);
  }
  getClass(state: number): string {
    switch (state) {
      case this.fontSizeState.Small:
        return 'global-small';
      case this.fontSizeState.Medium:
        return 'global-medium';
      case this.fontSizeState.Large:
        return 'global-large';
      default:
        return 'global-small';
    }

  }

  refreshToken() {
    this._request.refreshToken(localStorage.getItem("rt"), null, null, null)
      .then((res) => {
        if (res != null) {
          localStorage.setItem('ut', res.accessToken);
          localStorage.setItem('rt', res.refreshToken);
          this._auth.authControl(res.accessToken);
        }
      });
  }

  getPoiCategories() {
    this._request.getPoiCategoriesWithCategoryList(this._appsService.existCurrentCompany).then((res) => {
      if (res) {
        this._appsService.comingPoiCategories = res.poiCategoryGroupModel;
        this._appsService.poiCategories = res.poiCategories.subPoiCategories;
        this._appsService.topPoiCategories = res.poiCategories.topPoiCategories;
        this._appsService.poiCategoriesEn = res.poiCategories.subPoiCategoriesEn;
        this._appsService.topPoiCategoriesEn = res.poiCategories.topPoiCategoriesEn;
      }
    });
  }

}
